import { render, staticRenderFns } from "./AsignacionItems.vue?vue&type=template&id=31aaec12&scoped=true"
import script from "./AsignacionItems.vue?vue&type=script&lang=js"
export * from "./AsignacionItems.vue?vue&type=script&lang=js"
import style0 from "./AsignacionItems.vue?vue&type=style&index=0&id=31aaec12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aaec12",
  null
  
)

export default component.exports